import {
  BoxIcon,
  MilkIcon,
  ScissorsIcon,
  HighlighterIcon,
  BandageIcon,
  CircleDotIcon,
  BrainIcon,
  HeartIcon,
  RocketIcon,
  ListChecksIcon,
  HomeIcon,
  UsersIcon,
  LightbulbIcon,
  ScaleIcon,
  WrenchIcon,
  PlayCircleIcon,
  ZapIcon,
} from 'lucide-react'

export const images = {
  hero: 'https://cdn.magicpatterns.com/uploads/21Fwt3Gk8FCU5Gt2dpvrDw/pasted-image.png',
  screens: 'https://cdn.magicpatterns.com/uploads/bHmkCs6hniaJ2GETdnhD3G/pasted-image.jpg',
  building: 'https://cdn.magicpatterns.com/uploads/348zAmDSodjHas3BnaZy9e/pasted-image.jpg',
  bundle: 'https://cdn.magicpatterns.com/uploads/8GVZcPDZUTWFwKvm2eFPMY/pasted-image.jpg',
  cover: 'https://cdn.magicpatterns.com/uploads/xrj55PDs4c4SC6LU6buF8o/pasted-image.jpg',
  payments: 'https://cdn.magicpatterns.com/uploads/t1azuLCdmeQJqr6fEwg2LS/pasted-image.jpg',
}

export const heroFeatures = [
  { icon: PlayCircleIcon, label: 'Step-by-step videos' },
  { icon: HomeIcon, label: 'Household materials' },
  { icon: ZapIcon, label: 'Fast & fun results' },
]

export const screenRoutine = [
  'Passive consumption that drains natural curiosity.',
  'Irritability and tantrums when logging off.',
  'Free time passing without building real memories.',
  'Loss of hands-on, practical skills.',
  'Dependence on fast-paced, instant entertainment.',
]

export const innerGenius = [
  'Transforms boredom into meaningful creation.',
  'Develops patience and critical problem-solving.',
  'Builds massive confidence through tangible inventions.',
  'Sparks curiosity using everyday household items.',
  'Creates unique, high-quality family bonding moments.',
]

export const projects = [
  {
    name: 'Automatic Water Dispenser',
    level: 'Medium',
    image: 'https://cdn.magicpatterns.com/uploads/xA8fEeA7TrPpRFYbx1iekJ/pasted-image.jpg',
  },
  {
    name: 'Robotic Arm Rover',
    level: 'Challenging',
    image: 'https://cdn.magicpatterns.com/uploads/5hm6SvPhJSYpuGMvbXq7Jw/pasted-image.jpg',
  },
  {
    name: 'Bottle Diver Experiment',
    level: 'Easy',
    image: 'https://cdn.magicpatterns.com/uploads/wZaQhny6RPQZpbJNjpS2Nv/pasted-image.jpg',
  },
  {
    name: 'Motorized Elevator',
    level: 'Medium',
    image: 'https://cdn.magicpatterns.com/uploads/kYf42f2ZsugoJWB9auyE2t/pasted-image.jpg',
  },
]

export const childGets = [
  'Moving vehicles & robots built from scratch',
  'Step-by-step illustrated instructions',
  'Difficulty levels: easy, medium & challenging',
  'STEM skills: engineering, logic & creativity',
  'New projects added regularly',
  'Perfect for solo play or parent-child bonding',
]

export const materials = [
  { icon: BoxIcon, label: 'Cardboard' },
  { icon: MilkIcon, label: 'Bottles' },
  { icon: ScissorsIcon, label: 'Scissors' },
  { icon: HighlighterIcon, label: 'Markers' },
  { icon: BandageIcon, label: 'Tape' },
  { icon: CircleDotIcon, label: 'Bottle Caps' },
]

export const pillars = [
  {
    icon: BrainIcon,
    title: 'Problem-Solving Mindset',
    text: 'Trains their young minds to find real-world solutions.',
    tone: 'bg-mint text-teal',
  },
  {
    icon: HeartIcon,
    title: 'Unstoppable Confidence',
    text: 'Builds robust self-esteem through their own tangible inventions.',
    tone: 'bg-blush text-berry',
  },
  {
    icon: RocketIcon,
    title: 'Skills for Tomorrow',
    text: 'Sparks an early, passionate interest in science and technology (STEM).',
    tone: 'bg-butter text-tang',
  },
]

export const development = [
  { icon: ListChecksIcon, title: 'Easy-to-Follow', text: 'Simple, step-by-step guidance perfect for all skill levels.' },
  { icon: HomeIcon, title: 'Everyday Materials', text: 'Crafted using common household items you already own.' },
  { icon: UsersIcon, title: 'Learn Together', text: 'Enjoy collaborative activities and create lasting memories.' },
  { icon: LightbulbIcon, title: 'Creative Growth', text: 'Inspires outside-the-box thinking and original ideas.' },
  { icon: ScaleIcon, title: 'Logical Thinking', text: 'Helps young minds analyze data and make smart deductions.' },
  { icon: WrenchIcon, title: 'Problem Solving', text: 'Teaches kids how to think, test, and improve independently.' },
]

export const bonuses = [
  {
    tag: 'Bonus #1',
    title: 'Cardboard Arcade Pack',
    text: 'A fun video collection showing step-by-step how to build interactive games like a mini spaceball table, custom roulette wheels, and arcade machines using basic cardboard and a lot of imagination.',
    price: '$25.00',
    image: 'https://cdn.magicpatterns.com/uploads/pFBBtmFf5G7Rxj8gAPkRnU/pasted-image.jpg',
  },
  {
    tag: 'Bonus #2',
    title: 'The 5-Minute Papercraft Guide',
    text: "Your go-to handbook for quick, mess-free paper and cardboard crafts. Perfect for afternoons when you don't have special supplies but want an easy activity to pull them away from screens.",
    price: '$19.00',
    image: 'https://cdn.magicpatterns.com/uploads/jcKqGwejrdPbjT3aHxRCYT/pasted-image.jpg',
  },
  {
    tag: 'Bonus #3',
    title: 'Little Creators: Slimes & Sensory Play',
    text: 'A specialized guide packed with easy recipes for homemade slimes, modeling dough, and sensory textures. Ideal for keeping younger siblings happily entertained while making things with their hands.',
    price: '$15.00',
    image: 'https://cdn.magicpatterns.com/uploads/94R2nvRA1ygdzAX3gXNM54/pasted-image.jpg',
  },
]

export const valueStack = [
  { label: 'Maker Lab™ Complete Project Library (PDF Guides + Videos)', price: '$54.00' },
  { label: 'Bonus #1: Cardboard Arcade Pack', price: '$25.00' },
  { label: 'Bonus #2: The 5-Minute Papercraft Guide', price: '$19.00' },
  { label: 'Bonus #3: Little Creators: Slimes & Sensory Play', price: '$15.00' },
]

export const itsAbout = [
  "It's about swapping passive scrolling for simple, active play at home.",
  "It's about seeing them completely focused and genuinely proud of making a working toy.",
  "It's about helping them gain manual confidence by assembling things on their own.",
]

export const faqs = [
  {
    q: 'Is this a physical or digital product?',
    a: "Maker Lab™ is 100% digital. Right after your purchase you'll receive instant access to every PDF guide and step-by-step video — nothing ships, so you can start building today.",
  },
  {
    q: 'What ages is this recommended for?',
    a: 'Projects are designed for curious kids aged 4 to 12. Each one is marked easy, medium or challenging, so younger kids can build with a parent and older kids can work on their own.',
  },
  {
    q: "What if I don't have specialized science materials?",
    a: 'You don’t need any. Every project uses simple things you already have at home — cardboard, bottles, tape, markers, scissors and bottle caps. No robotics kits, no expensive parts.',
  },
  {
    q: 'Can I access the guides and files on any device?',
    a: 'Yes. Open them on your phone, tablet or computer — or print the PDFs. You get lifetime access, including new projects as they are added.',
  },
]

export const recentBuyers = [
  { name: 'Jessica', place: 'Austin, TX' },
  { name: 'Mariana', place: 'Miami, FL' },
  { name: 'Daniel', place: 'Toronto, ON' },
  { name: 'Emily', place: 'Denver, CO' },
  { name: 'Carlos', place: 'San Diego, CA' },
  { name: 'Sarah', place: 'Chicago, IL' },
]
